import loadable from "@loadable/component";
import SwitchTab from "../../components/Reusable/SwitchTab";
const StockTrialComponent = loadable(
  () => import("../../components/InventoryReport/StockTrialGroup")
);
const StockTrial = () => {
  const tabs = [
    {
      id: "stock-trial-normal",
      label: "Normal",
      href: "/accounting/stock-trial-normal",
    },
    {
      id: "stock-trial-group",
      label: "Grouped",
      href: "/accounting/stock-trial-group",
    },
  ];
  return (
    <>
      <SwitchTab tabs={tabs} /> <StockTrialComponent />
    </>
  );
};

export default StockTrial;
